import { TagField } from "@hireroo/app-store/widget/e/TagField";
import type { Widget } from "@hireroo/presentation";
import * as React from "react";

export type SuggestionItem = Widget.TagFieldProps["suggestions"][0];
export type DeleteDialogProps = SuggestionItem["deleteDialogProps"];

export type GenerateSuggestionsPropsArgs = {
  refresh: () => void;
  deleteTag: (tag: TagField.TagItem) => void;
  disableDeleteButton: boolean;
  deleteDialogProps: Pick<DeleteDialogProps, "items">;
};

export const useGenerateSuggestionsProps = (args: GenerateSuggestionsPropsArgs) => {
  const tags = TagField.useTags();

  const deleteDialogTargetTagName = TagField.useDeleteDialogTargetTagName();

  const handleClose = React.useCallback(() => {
    TagField.clearDeleteDialogTargetTagName();
  }, []);

  const handleYesButtonClick = React.useCallback(
    (tag: TagField.TagItem) => {
      handleClose();
      args.deleteTag(tag);
    },
    [args, handleClose],
  );

  const suggestions = React.useMemo((): Widget.TagFieldProps["suggestions"] => {
    return tags.map((tag): SuggestionItem => {
      return {
        valueId: tag.name,
        deleteButton: {
          onClick: () => {
            TagField.updateDeleteDialogTargetTagName(tag.name);
          },
        },
        deleteDialogProps: {
          name: tag.name,
          items: args.deleteDialogProps.items,
          dialog: {
            open: deleteDialogTargetTagName === tag.name,
            yesButton: {
              disabled: args.disableDeleteButton,
              onClick: () => handleYesButtonClick(tag),
            },
            noButton: {
              disabled: args.disableDeleteButton,
              onClick: handleClose,
            },
          },
        },
      };
    });
  }, [args, tags, deleteDialogTargetTagName, handleYesButtonClick, handleClose]);

  return {
    suggestions: suggestions,
  };
};
